<template>
  <v-row class="px-6">
    <v-col cols="12" md="6">
      <v-text-field
          @input="searchFunc"
          v-model="filterData.search"
          clearable
          class="rounded-lg pr-0 sm-font400-14"
          append-icon="mdi-magnify"
          label="جستجو"
          outlined
          hide-details
      ></v-text-field>
    </v-col>
    <v-col cols="12" md="3">
      <v-select
          :items="categoryArchiveList"
          class="rounded-lg sm-font400-14"
          label="وضعیت"
          item-text="text"
          item-value="id"
          hide-details
          clearable
          v-model="filterData.status"
          @change="searchFunc"
          outlined
      ></v-select>
    </v-col>
    <v-col cols="12" md="3">
      <v-select
          :items="courseTypeList"
          class="rounded-lg sm-font400-14"
          label="نوع دوره"
          item-text="text"
          item-value="id"
          hide-details
          clearable
          v-model="filterData.course_type"
          @change="searchFunc"
          outlined
      ></v-select>
    </v-col>
    <v-col cols="12" md="3">
      <v-select
          :items="teachers"
          class="rounded-lg sm-font400-14"
          label="نام مربی"
          item-text="title"
          item-value="id"
          hide-details
          clearable
          v-model="filterData.teacher_id"
          @change="searchFunc"
          outlined
      ></v-select>
    </v-col>
    <v-col cols="12" md="2">
      <v-btn
          block
          color="primary"
          @click="showToggleStatusByIds = true"
          class="white--text rounded-lg sm-font400-13"
          elevation="0"
          height="56"
          :disabled="ids.length === 0"
      >فعال و غیرفعال کردن
      </v-btn>
    </v-col>
    <v-col cols="12" md="2">
      <v-btn
          block
          color="positive"
          class="white--text rounded-lg sm-font400-13"
          elevation="0"
          height="56"
          to="/courses/class/create"
      >افزودن کلاس
      </v-btn>
    </v-col>
    <v-col cols="12" md="2">
      <v-btn
          block
          color="positive"
          class="white--text rounded-lg sm-font400-13"
          elevation="0"
          height="56"
          @click="initialCourse = true"
      >افزودن دوره مستقل
      </v-btn>
    </v-col>
    <v-col cols="12" md="2">
      <v-btn
          block
          outlined
          @click="exportExcel"
          class="thirdColor--text rounded-lg sm-font400-13"
          height="56"
      >
        <v-icon>mdi-upload</v-icon>
        خروجی اکسل
      </v-btn>
    </v-col>
    <v-dialog v-model="initialCourse" width="500">
      <v-card class="pa-10  text-center rounded-xl">
        <div class="d-flex mb-7">
          <p class="mb-0 sm-font600-16 textColorSecond--text">نوع دوره مادر را مشخص کنید</p>
        </div>
        <div>
          <v-radio-group v-model="selectedCourse">
            <div v-for="(item, index) in courseType" :key="item.id">
              <div class="d-flex align-center">
                <v-radio
                    inset
                    :value="item.id"
                    class="mb-0 me-5"
                    color="thirdColor"
                ></v-radio>
                <label class="sm-font400-14 primary--text">{{ item.text }}</label>
              </div>
              <v-divider class="my-4" v-if="index < courseType.length -1"/>
            </div>
          </v-radio-group>
        </div>
        <v-btn @click="initialCourse = false" elevation="0"
               class="black--text border rounded-lg mt-3 me-4" height="32">بازگشت
        </v-btn>
        <v-btn :loading="loading" elevation="0" @click="gotoForm" color="secondary"
               class="white--text rounded-lg mt-3" height="32">ادامه
        </v-btn>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showToggleStatusByIds" width="500" @click:outside="clearList">
      <v-card class="pa-10  text-center rounded-xl">
        <h3 class="mb-5">آیا از فعال/غیرفعال کردن دسته بندی ها مطمئن
          هستید؟</h3>
        <v-btn :loading="loadingStatusIds" @click="confirmToggleStatusByIds" block color="positive"
               class="white--text rounded-xl mt-3" height="48">ارسال
        </v-btn>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import courseApi from "@/Services/modules/courses"
import reports from "@/Services/modules/reports"

export default {
  name: "filter-page",
  props: {
    ids: {
      type: Array,
    },
    filterSearch: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      loadingStatusIds: false,
      teachers: [],
      
      courseType: null,
      selectedCourse: null,
      loading: false,
      initialCourse: false,
      showToggleStatusByIds: false,
      categoryArchiveList: [
        {
          id: 'Performing',
          text: "در حال اجرا"
        },
        {
          id: 'Registering',
          text: "در حال ثبت نام",
        },
        {
          id: 'Ended',
          text: "پایان یافته",
        }
      ],
      courseTypeList: [
        // {
        //   id: "SubCourse",
        //   text: "زیردوره"
        // },
        // {
        //   id: "IndependentCourse",
        //   text: "مستقل",
        // }
        {
          id: "Online",
          text: "کوچینگ"
        },
        {
          id: "Offline",
          text: "بوتکمپ",
        },
        {
          id: "Online_Offline",
          text: "تکمیلی",
        }
      ],
      filterData: {
        page: Number(this.filterSearch.page) || Number(this.$route.query.page) || 1,
        search: this.filterSearch.search || this.$route.query.search || "",
        status: this.filterSearch.status || this.$route.query.status || null,
        course_type: this.filterSearch.course_type || this.$route.query.course_type || null,
        teacher_id: this.filterSearch.teacher_id || this.$route.query.teacher_id || null,
      },
    }
  },
  mounted() {
    this.courseType = [
      {
        id: "Offline",
        text: "بوت کمپ"
      },
      {
        id: "Online_Offline",
        text: "دوره تکمیلی"
      },
    ]
    this.getTeachers()
  },
  methods: {
    getTeachers() {
      reports.getTeachers().then((res) => {
        this.teachers = (res.data.results || []).map((teacher) => ({
          id: teacher.id,
          title: `${teacher.first_name} ${teacher.last_name}`.trim(),
        }))
      })
    },
    searchFunc() {
      this.filterData.page = 1
      this.$router.push({
        query: {
          ...this.$route.query,
          search: this.filterData.search,
          is_shown: this.filterData.is_shown,
          status: this.filterData.status,
          course_type: this.filterData.course_type,
          teacher_id: this.filterData.teacher_id,
          page: this.filterData.page
        }
      })
      this.$emit("getData", this.filterData)
    },
    clearList() {
      this.$emit("clearIdList")
    },
    submitAddCategory() {
    },
    confirmToggleStatusByIds() {
      this.loadingStatusIds = true
      courseApi.multipleStatusActionOnClasses({ids: this.ids, is_active: false}).finally(() => {
        this.showToggleStatusByIds = false
        this.$emit("getData", this.filterData)
      }).finally(()=> { 
        this.loadingStatusIds = false
      })
    },
    exportExcel() {
      courseApi.getClassExcel(this.filterData).then((response) => {
        window.open(URL.createObjectURL(response.data));
      })
    },
    gotoForm() {
      this.$router.push({
        path: '/courses/class/create-independent', query: {
          course_type: this.selectedCourse
        }
      });
    },
  }
}
</script>

<style scoped>

</style>
